import router from '../router';
import axios from 'axios';
const state = {
    rawToken: '',
    token: '', 
    status: '',
    menuVisible: false,
    isActive: false,
    sessions: {}

};

const getters = {
	isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
};

const mutations = {
	setRawToken(state, rawToken) {
        state.rawToken = rawToken;
    },
    authSuccess(state, token, rawToken) {
        state.status = 'success';
        state.token = token;
        state.rawToken = rawToken;
    },
    toggleDrawer(state) {
        state.menuVisible = !state.menuVisible
        if(state.menuVisible == true) {
            state.isActive = true
        } else {
            setTimeout(() => {
                state.isActive = false
            }, 100)
        }
    },
    resetDrawer(state) {
        state.menuVisible = false
        state.isActive = false
    },
    logout(state) {
        localStorage.removeItem('status')
        localStorage.removeItem('companies')
        localStorage.removeItem('token')
        localStorage.removeItem('raw_token')
        delete axios.defaults.headers['Authorization']
        state.status = '';
        state.token = '';
        state.raw_token = '';
        state.companies = '';
        state.selectedContact = '';
        state.selectedPaymentTerm = '';
        state.selectedDepositToContact ='';
        state.invoice_title = '';
        state.invoice_number = '';
        state.items = [];
        state.payments = [];
        state.currentCompany = {};
        state.sessions = {};
        router.go('/login')
    },
    setSessions(state, session) {
	    state.sessions = session
    }
};

const actions = {
	setRawToken({commit}, rawToken) {
        commit('setRawToken', rawToken);
    },
    setAuthSuccess({commit}, data) {
        commit('authSuccess', data.authorization_token, data.raw_token);
    },
    logout({commit}) {
        commit('logout')
    },
    setSessions({commit}, sessions) {
	    commit('setSessions', sessions);
    }
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};